export default __webpack_public_path__ + "static/media/bell.e790617a.svg";